module.exports = __webpack_public_path__ + "img/asocoins-falling-coins.ed1aedfd.webp";